import { ExchangeRate2Response } from '@acme/api';
import { Field, Separator } from '@acme/foundation';

interface ProviderInfoProps {
  provider: ExchangeRate2Response;
}

export const ProviderInfo = ({ provider }: ProviderInfoProps) => {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <span className="text-sm text-gray-500">
          Курс поставщика для разных объемов валюты
        </span>

        <div className="flex flex-col gap-2">
          {provider.ranges?.map((r, idx) => (
            <div className="text-gray-500 hover:text-gray-900" key={idx}>
              {`От ${r.min} до ${r.max} курс: ${r.price}`}
            </div>
          ))}
        </div>
      </div>

      <Separator className="-mx-6" />

      <div className="text-lg font-semibold">
        Реквизиты поставщика ликвидности
      </div>

      <div className="grid grid-cols-3 gap-3">
        <Field label="Название организации" value={provider?.name} />
        <Field label="ИНН" value={provider?.inn || '-'} />
        <Field label="КПП" value={provider?.kpp || '-'} />
        <Field label="ОКПО" value={provider?.okpo || '-'} />
        <Field label="ОКАТО" value={provider?.okato || '-'} />
        <Field
          label="Юридический адрес"
          value={provider?.legalAddress || '-'}
        />
      </div>
    </div>
  );
};
